import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { template } from 'lodash'

const TEXT = { fontSize: 12, fill: '#5F5E5A' }
const TITLE = { fontSize: 14, fontWeight: 'bold', fill: '#2C2C2A' }
const INFO_LETTER = { fontSize: 13, fill: '#5F5E5A' }
const SELECT_LETTER = { fontSize: 14, fontWeight: 'bold', fill: '#1D9E75' }
const RECALL = { stroke: '#888780', strokeWidth: 0.5, strokeDasharray: '4 3', fill: 'none' }
const GRADUATION = { stroke: '#2C2C2A', strokeWidth: 0.5 }
const INFO_LINE = { stroke: '#888780', strokeWidth: 1.2, markerStart: 'url(#hydroSchemaInfo)', markerEnd: 'url(#hydroSchemaInfo)' }
const SELECT_LINE = { stroke: '#1D9E75', strokeWidth: 2, markerStart: 'url(#hydroSchemaSelect)', markerEnd: 'url(#hydroSchemaSelect)' }

const Marker = ({ id, color, size }) => (
    <marker id={id} viewBox='0 0 10 10' refX='8' refY='5' markerWidth={size} markerHeight={size} orient='auto-start-reverse'>
        <path d='M2 1L8 5L2 9' fill='none' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </marker>
)

Marker.propTypes = {
    id: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
}

const HydrometryReferenceLevelSchema = ({ ng }) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 680 545' role='img' fontFamily='Arial, Helvetica, sans-serif' style={{ width: '100%', height: 'auto' }}>
        <defs>
            <Marker id='hydroSchemaAxis' color='#5F5E5A' size={6} />
            <Marker id='hydroSchemaInfo' color='#888780' size={6} />
            <Marker id='hydroSchemaSelect' color='#1D9E75' size={5} />
        </defs>

        <text style={TEXT} x='40' y='55'>{template(i18n.refLevelSchemaAxis)({ ng })}</text>
        <line x1='110' y1='420' x2='110' y2='70' stroke='#5F5E5A' strokeWidth='1.5' markerEnd='url(#hydroSchemaAxis)' />
        <text style={TEXT} x='100' y='96' textAnchor='end'>{i18n.refLevelSchemaRadar}</text>
        <text style={TEXT} x='100' y='204' textAnchor='end'>{i18n.refLevelSchemaWaterSurface}</text>
        <text style={TEXT} x='100' y='304' textAnchor='end'>{i18n.refLevelSchemaSensor}</text>
        <text style={TEXT} x='100' y='334' textAnchor='end'>{i18n.refLevelSchemaGaugeZero}</text>
        <text style={TEXT} x='100' y='364' textAnchor='end'>{i18n.refLevelSchemaBottom}</text>
        <text style={TEXT} x='100' y='414' textAnchor='end'>{template(i18n.refLevelSchemaZero)({ ng })}</text>

        <polygon points='120,170 150,170 260,360 440,360 560,170 640,170 640,380 120,380' fill='#D3D1C7' />
        <polyline points='120,170 150,170 260,360 440,360 560,170 640,170' fill='none' stroke='#5F5E5A' strokeWidth='1' />
        <polygon points='167,200 541,200 440,360 260,360' fill='#85B7EB' />
        <line x1='167' y1='200' x2='541' y2='200' stroke='#185FA5' strokeWidth='1' />

        <rect x='271' y='140' width='10' height='190' fill='#FFFFFF' stroke='#2C2C2A' strokeWidth='1' />
        <line style={GRADUATION} x1='271' y1='160' x2='277' y2='160' />
        <line style={GRADUATION} x1='271' y1='190' x2='277' y2='190' />
        <line style={GRADUATION} x1='271' y1='220' x2='277' y2='220' />
        <line style={GRADUATION} x1='271' y1='250' x2='277' y2='250' />
        <line style={GRADUATION} x1='271' y1='280' x2='277' y2='280' />
        <line style={GRADUATION} x1='271' y1='310' x2='277' y2='310' />
        <text style={TEXT} x='276' y='128' textAnchor='middle'>{i18n.refLevelSchemaGauge}</text>

        <rect x='336' y='294' width='18' height='12' rx='3' fill='#F0997B' stroke='#993C1D' strokeWidth='0.5' />
        <line x1='580' y1='60' x2='580' y2='170' stroke='#2C2C2A' strokeWidth='2' />
        <line x1='472' y1='70' x2='580' y2='70' stroke='#2C2C2A' strokeWidth='2' />
        <rect x='462' y='72' width='20' height='20' rx='3' fill='#F0997B' stroke='#993C1D' strokeWidth='0.5' />
        <text style={TEXT} x='472' y='58' textAnchor='middle'>{i18n.refLevelSchemaRadar}</text>

        <line style={RECALL} x1='472' y1='92' x2='472' y2='200' />
        <line style={RECALL} x1='110' y1='92' x2='462' y2='92' />
        <line style={RECALL} x1='482' y1='92' x2='508' y2='92' />
        <line style={RECALL} x1='110' y1='200' x2='167' y2='200' />
        <line style={RECALL} x1='541' y1='200' x2='610' y2='200' />
        <line style={RECALL} x1='110' y1='300' x2='336' y2='300' />
        <line style={RECALL} x1='354' y1='300' x2='372' y2='300' />
        <line style={RECALL} x1='110' y1='330' x2='271' y2='330' />
        <line style={RECALL} x1='281' y1='330' x2='328' y2='330' />
        <line style={RECALL} x1='110' y1='360' x2='260' y2='360' />
        <line style={RECALL} x1='110' y1='410' x2='610' y2='410' />

        <line style={INFO_LINE} x1='320' y1='302' x2='320' y2='328' />
        <text style={INFO_LETTER} x='312' y='319' textAnchor='end'>D</text>
        <line style={INFO_LINE} x1='365' y1='298' x2='365' y2='202' />
        <text style={INFO_LETTER} x='373' y='254'>C</text>
        <line style={INFO_LINE} x1='500' y1='94' x2='500' y2='198' />
        <text style={INFO_LETTER} x='508' y='150'>B</text>

        <line style={SELECT_LINE} x1='255' y1='328' x2='255' y2='202' />
        <text style={SELECT_LETTER} x='247' y='270' textAnchor='end'>H</text>
        <line style={SELECT_LINE} x1='600' y1='202' x2='600' y2='408' />
        <text style={SELECT_LETTER} x='608' y='305'>N</text>

        <text style={{ ...TITLE, fill: '#1D9E75' }} x='40' y='455'>{i18n.refLevelSchemaSelectable}</text>
        <text style={TEXT} x='40' y='479'>{`H  ${i18n.refLevelSchemaGaugeHeight}`}</text>
        <text style={TEXT} x='40' y='501'>{`N  ${template(i18n.refLevelSchemaHydroNg)({ ng })}`}</text>
        <text style={TITLE} x='360' y='455'>{i18n.refLevelSchemaInformative}</text>
        <text style={TEXT} x='360' y='479'>{`B  ${i18n.refLevelSchemaRadarAirGap}`}</text>
        <text style={TEXT} x='360' y='501'>{`C  ${i18n.refLevelSchemaWaterOnSensor}`}</text>
        <text style={TEXT} x='360' y='523'>{`D  ${i18n.refLevelSchemaSensorSetting}`}</text>
    </svg>
)

HydrometryReferenceLevelSchema.propTypes = {
    ng: PropTypes.string,
}

export default HydrometryReferenceLevelSchema
